import axios from "axios";
import config from "../config";
import { handleUnauthorizedAndRelogin } from "./authSession";

const api = axios.create({
  baseURL: config.apiUrl,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

const shouldRelogin = (error) => {
  if (error?.response?.status !== 401) return false;

  const message = String(error?.response?.data?.message || "").toLowerCase();
  const reason = String(error?.response?.data?.error || "").toLowerCase();
  const combined = `${message} ${reason}`;

  return (
    combined.includes("invalid token") ||
    combined.includes("token expired") ||
    combined.includes("unauthorized")
  );
};

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const isAuthCallbackPage =
      typeof window !== "undefined" &&
      window.location.pathname.includes("/auth/callback");

    if (!isAuthCallbackPage && shouldRelogin(error)) {
      handleUnauthorizedAndRelogin();
    }
    return Promise.reject(error);
  }
);

export default api;
